import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import Player from './Player';
import tokens from '../../theme/tokens';
import { MarcadoresLance, contarLances } from '../../components/Lances';
import NotaJogador from '../../components/NotaJogador';
import CompletouChip from '../../components/CompletouChip';

// Alça de arrastar (toque e mouse) usada nos times e na fila.
export const AlcaArrastar = ({ onPointerDown }) => (
  <Box
    onPointerDown={onPointerDown}
    aria-label="Arrastar jogador"
    sx={{ display: 'grid', placeItems: 'center', alignSelf: 'stretch', px: 0.25, touchAction: 'none', cursor: 'grab', color: 'text.disabled' }}
  >
    <DragIndicatorRoundedIcon fontSize="small" />
  </Box>
);

// Estilo do cartão durante o arraste: origem apagada, alvo destacado.
export const estiloArraste = ({ origem, alvo }) => ({
  userSelect: 'none', // segurar o card no celular não seleciona o texto
  WebkitUserSelect: 'none',
  ...(origem && { opacity: 0.4 }),
  ...(alvo && { outline: `2px dashed ${tokens.color.info}`, bgcolor: tokens.color.infoSoft }),
  transition: 'background-color 120ms',
});

/**
 * Jogadores de um time. Com `arrastar` e `lista` (time0/time1), cada jogador pode ser arrastado e receber drops.
 * Com `eventos`, mostra gols/assistências/cartões; com `onJogador`, tocar no jogador abre os lances dele.
 * `notas`: { user_name: { nota, origem, detalhe } } da formação dos times.
 */
const Team = ({ team = [], lista, arrastar, eventos, onJogador, vitorias = {}, notas = {}, completacoes = {} }) => {
  const indiceTime = lista === 'time1' ? 1 : 0;
  return (
    <Stack spacing={0.75}>
      {team.map((player) => {
        const estado = arrastar ? arrastar.estado(lista, player) : {};
        const contagem = eventos ? contarLances(eventos, indiceTime, player.user_name) : null;
        return (
          <Stack
            key={player.user_name}
            direction="row"
            alignItems="center"
            spacing={0.5}
            data-drop={arrastar ? `${lista}|${player.user_name}` : undefined}
            sx={{ px: arrastar ? 0.5 : 1.25, py: 1, borderRadius: 2, bgcolor: 'background.default', ...estiloArraste(estado) }}
          >
            {arrastar && <AlcaArrastar onPointerDown={(e) => arrastar.iniciar(e, lista, player)} />}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              onClick={onJogador ? () => onJogador({ time: indiceTime, user_name: player.user_name }) : undefined}
              role={onJogador ? 'button' : undefined}
              title={onJogador ? 'Lançar gol, assistência ou cartão' : undefined}
              sx={{ flexGrow: 1, minWidth: 0, cursor: onJogador ? 'pointer' : 'default', borderRadius: 1.5, '&:hover': onJogador ? { bgcolor: 'action.hover' } : undefined }}
            >
              <Player player={player} vitorias={vitorias[player.user_name] || 0} />
              {contagem && <MarcadoresLance contagem={contagem} />}
            </Stack>
            <CompletouChip vezes={completacoes[player.user_name]} />
            <NotaJogador info={notas[player.user_name]} />
          </Stack>
        );
      })}
    </Stack>
  );
};

export default Team;
